import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { AlertsBannersDefinitionsResponse } from "@/api/backofficeRest/generated/model"
import { IAlertsBannersCatalogue } from "@/models/alertsBanners/alertsBanners.types"
import { AlertsBannersParser } from "@/models/alertsBanners/alertsBanners.parser"

class AlertsBannersServiceClass {
  getDefinitions(): QueryResult<IAlertsBannersCatalogue | null> {
    return useQuery<
      AlertsBannersDefinitionsResponse,
      IAlertsBannersCatalogue | null
    >({
      ...BackofficeRestQueries.alertsBanners.definitions,
      placeholderData: null,
      useRawResponse: true,
      parserFn: (data) => AlertsBannersParser.toDomain(data),
    })
  }
}

export const AlertsBannersService = new AlertsBannersServiceClass()
